<template>
  <div style="width: 1200px;margin: 0 auto;height: 100%" class="xh">
    <el-tabs :tab-position="tabPosition" v-model="activeName" >
      <el-tab-pane label="会员注册" name="first" style="text-align: left;padding-top: 10px">
        <div style="width: 500px;margin: 0 auto">
          <el-form ref="form" :model="form" >
            <el-form-item label="姓名" label-width="68px">
              <el-input v-model="form.username" ></el-input>
            </el-form-item>
            <!-- <el-form-item label="昵称" label-width="68px">
              <el-input v-model="form.nickname" ></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="真实姓名" label-width="68px">
              <el-input v-model="form.realname" ></el-input>
            </el-form-item> -->
            <el-form-item label="手机号码" label-width="68px">
              <el-input v-model="form.phone" ></el-input>
            </el-form-item>
            <!-- <el-form-item label="头像" style="padding-left: 25px;">
              <el-upload
                class="upimg"
                ref="uploadimg"
                action=""
                list-type="picture-card"
                accept=".jpg,.png,.jpeg"
                :on-remove="handleRemove"
                :on-change="UploadImage"
                :limit="1"
                :file-list="fileList"
                :auto-upload="false"
              >
                <i class="el-icon-plus" style="float: left;line-height: 50px;margin-left: 10px"></i>
                <template #tip>
                  <div style="font-size: 12px;color: #919191;">
                    上传类型:JPG、JPEG、PNG
                  </div>
                </template>
              </el-upload>
              <el-dialog v-model="dialogVisible" style="line-height: 0;">
                <img style="width: 100%;height: 100%"  :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item> -->

            <el-form-item label="密码" label-width="68px">
              <el-input v-model="form.password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" label-width="68px">
              <el-input v-model="form.re_password"></el-input>
            </el-form-item>
            <!-- <el-form-item label="验证码" label-width="68px">
              <el-input v-model="form.yzm"></el-input>
              <div @click="refreshCode"><s-identify :identifyCode="identifyCode" ></s-identify></div>
            </el-form-item> -->
            <el-form-item label="注册码" label-width="68px">
              <el-input v-model="form.code"></el-input>
            </el-form-item>
            <el-form-item style="width: 300px;" label-width="90px">
              <el-button type="primary" @click="onSubmit">注册</el-button>
              <el-button>取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>

</template>

<script>

import axios from "axios";

export default {
  name: "Register",
  data(){
    return{
      tabPosition: 'left',
      activeName: 'first',
      fileList:[],
      dialogImageUrl: '',
      dialogVisible: false,
      form: {
        username: '',
        nickname: '',
        realname: '',
        phone: '',
        image:'',
        password: '',
        re_password: '',
        yzm: '',
        code:'',
      },
      identifyCodes: "1234567890",
      identifyCode: ""
    }
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  methods: {
    //上传图片的方法
    UploadImage(file,filelist) {
      let fd = new FormData()
      fd.append('file', file.raw)
      axios.post('/api/index/uploadHead', fd, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
        this.form.image = response.data.data.url;
      })
    },
    //移除图片功能
    handleRemove(file, fileList) {
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
          ];
      }
    },
    onSubmit() {
      if(this.form.username == ''){
        this.$message.error('姓名不能为空')
        return
      }else if(this.form.password == ''){
        this.$message.error('密码不能为空')
        return
      // }else if(this.form.yzm == ''){
      //   this.$message.error('验证码不能为空')
      //   return
      // }else if(this.form.yzm.toLowerCase() !== this.identifyCode.toLowerCase()) {
      //   this.$message.error('请填写正确验证码')
      //   this.refreshCode()
      //   return

       }
      else if(this.form.phone == ''){
        this.$message.error('手机号不能为空')
        return
      // }else if(this.form.realname == ''){
      //   this.$message.error('真实姓名不能为空')
      //   return
      }else if(this.form.re_password == ''){
        this.$message.error('确认密码不能为空')
        return
      }else if(this.form.code == ''){
        this.$message.error('注册码不能为空')
        return
      }
      let params = {
        username: this.form.username,
        password: this.form.password,
        // nickname: this.form.nickname,
        phone:this.form.phone,
        // head_img:this.form.image,
        // realname: this.form.realname,
        re_password:this.form.re_password,
        code:this.form.code,

      }
      this.axios.post('/api/index/reg',params).then((response) => {
        if(response.data.code == 1){
          this.$message({
            showClose: true,
            type:'success',
            message:'注册成功',
            duration:2000
          })
          this.$router.push({path:'/Login'})
        }else{
          this.$message({
            showClose: true,
            type:'error',
            message:response.data.code,
            duration:2000
          })
        }
      }).catch(function (error) {
        console.log(error)
      });
    },
  }
}
</script>

<style scoped>
.upimg{
  text-align: left;
  padding-left: 40px;
}
.upimg /deep/ .el-upload--picture-card {
  width: 50px;
  height: 50px;
}
.upimg /deep/ .el-upload-list__item {
  width: 50px;
  height: 50px;
}
.xh >>>.el-tabs__nav-wrap::after {
  position: static !important;
}
.xh >>>.el-tabs__active-bar {
  background-color: transparent !important;
}
.el-input {
  width: 200px;
  float: left;
}

</style>



// WEBPACK FOOTER //
// src/components/view/Register.vue